import { FadeUp, MaskedLines, Eyebrow } from "@/components/Reveal";

const CARDS = [
  {
    label: "Geri Bildirim",
    text: "“Fiziksel olarak aradığım çekimi hissedemedim.”",
    rotate: "sm:-rotate-2",
  },
  {
    label: "Geri Bildirim",
    text: "“İletişim tarzımızın bana uygun olmadığını hissettim.”",
    rotate: "sm:rotate-1 sm:translate-y-4",
  },
  {
    label: "Geri Bildirim",
    text: "“Hayat düzenimiz uyuşmadı.”",
    rotate: "sm:-rotate-1",
  },
];

export default function Feedback() {
  return (
    <section data-testid="feedback-section" className="py-24 sm:py-36 bg-ivory">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <FadeUp>
            <Eyebrow>Geri Bildirim</Eyebrow>
          </FadeUp>
          <h2 className="mt-7 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-ink">
            <MaskedLines
              lines={[
                "Her deneyim, bir sonraki",
                <em key="em" className="italic text-burgundy">
                  seçimi şekillendirir.
                </em>,
              ]}
            />
          </h2>
          <FadeUp delay={0.2} className="mt-6 text-base font-light text-ink-soft/90 leading-relaxed">
            Bir eşleşmenin neden sana uygun olduğunu ya da olmadığını paylaşabilirsin. Geri bildirimlerin, sonraki
            seçimlerinin daha kişisel ve anlamlı hale gelmesine yardımcı olur.
          </FadeUp>
        </div>

        <div className="mt-14 sm:mt-20 grid sm:grid-cols-3 gap-5 sm:gap-7">
          {CARDS.map((c, i) => (
            <FadeUp key={i} delay={i * 0.12}>
              <div
                data-testid={`feedback-card-${i}`}
                className={`bg-white/90 border border-burgundy/10 rounded-[6px] p-7 sm:p-8 shadow-[0_14px_36px_rgba(38,32,32,0.06)] transition-transform duration-500 hover:rotate-0 hover:translate-y-0 ${c.rotate}`}
              >
                <p className="text-[10px] uppercase tracking-[0.22em] text-gold font-semibold">{c.label}</p>
                <p className="mt-4 font-serif italic text-lg sm:text-xl text-ink leading-relaxed">{c.text}</p>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.3} className="mt-12 flex items-center gap-4 text-xs text-ink-muted tracking-wide">
          <span className="h-px w-10 bg-burgundy/30" aria-hidden="true" />
          Geri bildirimlerin yalnızca eşleşme deneyimini iyileştirmek için kullanılır.
        </FadeUp>
      </div>
    </section>
  );
}
